import {createContext, useContext, useState, type ReactNode} from "react";

export type FocusedNode = {id: string; isNew: boolean} | null;

interface CommentContextValue {
    isOpen: boolean;
    focusedNode: FocusedNode;
    setFocusedNode: (id: string | undefined, isNew: boolean) => void;
    closePanel: () => void;
}

const CommentContext = createContext<CommentContextValue | undefined>(
    undefined,
);

export const CommentProvider = ({children}: {children: ReactNode}) => {
    const [isOpen, setOpen] = useState(false);
    const [focusedNode, setFocusedNodeState] = useState<FocusedNode>(null);

    const setFocusedNode = (id: string | undefined, isNew: boolean) => {
        if (id !== undefined) {
            setOpen(true);
            setFocusedNodeState({id, isNew});
        } else {
            setFocusedNodeState(null);
        }
    };

    const closePanel = () => {
        setOpen(false);
        setFocusedNodeState(null);
    };

    return (
        <CommentContext.Provider
            value={{isOpen, focusedNode, setFocusedNode, closePanel}}
        >
            {children}
        </CommentContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useComment = (): CommentContextValue => {
    const ctx = useContext(CommentContext);
    if (!ctx)
        throw new Error("useComment must be used within a CommentProvider");
    return ctx;
};
